<!--
 * @Description: 二次验证 这是个响应式的页面
 * @Autor: lwq
 * @Date: 2020-08-17 17:30:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-29 10:33:18
 * @FilePath: \web_admin\src\views\forget-password\index.vue
-->
<template>
  <div class="forget-password">
    <!-- 背景 -->
    <!-- <div class="bgd_right_box"
         style="position:absolute;">
      <mrc_ess_svgIcon iconClass="right"
                       class="bgd_one bgd_right_box_img" />
    </div>

    <div class="bgd_left_box"
         style="position:absolute;">
      <mrc_ess_svgIcon iconClass="left"
                       class="bgd_two bgd_left_box_img" />
    </div> -->
    <mrc_ess_svgIcon iconClass="left" class="left_bg"
      :style="{ left: -bgstyle / 2 + 'px', width: bgstyle + 'px', height: bgstyle + 'px' }" />
    <mrc_ess_svgIcon iconClass="right" class="right_bg"
      :style="{ right: -bgstyle / 2 + 'px', width: bgstyle + 'px', height: bgstyle + 'px' }" />
    <!-- webPc 的页面 -->
    <div class="webPc" v-if="webPc">
      <!-- 发送邮件 -->
      <v-card class="webSendMail" elevation="24" v-if="sendMail">
        <div class="forgot_title text-h3 mb-4">{{ $t('label_secondary_verification') }}</div>
        <div class="text-body-s  " style="text-align:left;color:rgba(0, 0, 0, 0.38)">{{ $t('label_sent_email_address') }}
        </div>
        <div class="text-body-m" style="text-align:left;"> {{ user_primary_email }}</div>
        <mrc_ess_input label=" " :placeholder="$t('label_enter_your_code')" background-color="#fff"
          style="margin-top: 24px" @keyupEnter="submit_code" @input="$v.sendEmailParams.auth_code.$touch()"
          @blur="$v.sendEmailParams.auth_code.$touch()" v-model.trim="sendEmailParams.auth_code" :error-messages="$errors('sendEmailParams', 'auth_code', requiredRule)
            ">
        </mrc_ess_input>
        <div style="text-align:left;">
          <span v-if="setTime" style="color:rgba(0, 0, 0, 0.38)">
            <span class="mr-1"> {{ timeNum }}</span>
            {{ $t('label_resend_i_seconds') }}</span>
          <v-btn v-if="!setTime" rounded :loading='btnloading' text depressed color="#C6DBFD"
            class="primary--text text-body-m ml-n4" @click="getCode">
            <!-- {{$t('label_get_verification_code')}} -->
            {{ $t('label_resendEmail') }}
          </v-btn>
        </div>
        <mrc_ess_submitBtn backgroundColor="#fff" class="mt-6" :loading="loading" @success="submit_code"
          @cancel="backHandler"></mrc_ess_submitBtn>
      </v-card>
    </div>

    <!-- 这是手机的输入框 -->
    <div class="phoneH5" v-else>
      <v-card v-if="sendMail" elevation="24" class="sendMail">
        <div class="forgot_title text-h3 mb-4">{{ $t('label_secondary_verification') }}</div>
        <div class="text-body-s  " style="text-align:left;color:rgba(0, 0, 0, 0.38)">{{ $t('label_sent_email_address') }}
        </div>
        <div class="text-body-m" style="text-align:left;"> {{ user_primary_email }}</div>
        <mrc_ess_input label=" " :placeholder="$t('label_enter_your_code')" background-color="#fff"
          style="margin-top: 24px" @keyupEnter="submit_code" @input="$v.sendEmailParams.auth_code.$touch()"
          @blur="$v.sendEmailParams.auth_code.$touch()" v-model.trim="sendEmailParams.auth_code" :error-messages="$errors('sendEmailParams', 'auth_code', requiredRule)
            ">
        </mrc_ess_input>
        <div style="text-align:left;">
          <span v-if="setTime" style="color:rgba(0, 0, 0, 0.38)">{{ timeNum }}{{ $t('label_resend_i_seconds') }}</span>
          <v-btn v-if="!setTime" rounded :loading='btnloading' text depressed color="#C6DBFD"
            class="primary--text text-body-m ml-n4" @click="getCode">
            <!-- {{$t('label_get_verification_code')}} -->
            {{ $t('label_resendEmail') }}
          </v-btn>
        </div>
        <mrc_ess_submitBtn backgroundColor="#fff" class="mt-6" :loading="loading" @success="submit_code"
          @cancel="backHandler">
        </mrc_ess_submitBtn>
      </v-card>
    </div>
    <!-- 这是页面底部的版本信息 -->
    <div class="bottom">
      <p>
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved
        <a href="https://privacy.essencehr.io/" target="_blank" class="hover1"
          style="color:#ffffff;text-decoration: none;caret-color: #fff!important;">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/" target="_blank" class="hover2"
          style="color:#ffffff;text-decoration: none;caret-color: #fff!important;">Term of Use.</a>
      </p>
    </div>
    <!-- 这是发送后的提示弹窗 -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { login as loginInterface, getMenu } from "@/service/api/login.js"
import {
  get_code, login_auth
} from "@/service/api/secondary_confirmation"
export default {
  components: {},
  props: {},
  data() {
    return {
      btnloading: false,
      timeNum: 60,
      timer: "",
      setTime: false,
      encrypt_user_account: "",
      login_url: "",
      disabled: false,
      sendMail: false,
      sendEmailParams: {
        auth_code: "",
      },
      screenSize: "",
      // 是web的尺寸 true  手机的尺寸 false
      webPc: true,
      loading: false,
    }
  },
  validations: {
    sendEmailParams: {
      auth_code: {
        required,
      },
    },
  },
  computed: {
    user_primary_email() {
      return this.$store.state.userData.user_primary_email
    },
    bgstyle() {
      let size = 0;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = 0;
          break;
        case "sm":
          size = 600;
          break;
        case "md":
          size = 900;

          break;
        case "lg":
          size = 1000;

        case "xl":
          size = 1200;

          break;
        default:
          break;
      }
      return size;
    },
  },
  async created() {
    this.sendMail = true
    const that = this
    that.screenSize = document.documentElement.clientWidth
    if (that.screenSize > 750) {
      that.webPc = true
    } else {
      that.webPc = false
    }
    this.resize(function () {
      that.screenSize = document.documentElement.clientWidth
      if (that.screenSize > 750) {
        that.webPc = true
      } else {
        that.webPc = false
      }
    })
  },
  watch: {},
  mounted() {
    this.setTime = true
    this.set_count_down()
  },
  methods: {
    set_count_down() {
      this.timer = setInterval(() => {
        --this.timeNum
        if (this.timeNum == 0) {
          clearInterval(this.timer);
          this.setTime = false
          this.timeNum = 60
        }
      }, 1000);
    },
    async getCode() {
      await this.$store.dispatch("setPubk")
      this.btnloading = true
      let user_account = this.$encrypt({
        msg: this.$route.query.ua,
        key: this.$store.getters.pubk,
      })
      this.encrypt_user_account = user_account
      get_code({
        user_account
      }).then(res => {
        this.btnloading = false
        if (res.code == 200) {
          this.setTime = true
          this.set_count_down()
        }
      }).catch(err => {
        this.btnloading = false
      })
    },
    // 提交验证码
    async submit_code() {
      this.$v.sendEmailParams.$touch()
      if (this.$v.sendEmailParams.$error) return
      this.loading = true
      await this.$store.dispatch("setPubk")
      const res = await login_auth({
        user_account: this.$encrypt({
          msg: this.$route.query.ua,
          key: this.$store.getters.pubk,
        }),
        auth_code: this.sendEmailParams.auth_code
      })
      this.loading = false
      if (res.code == 200) {
        this.$store.dispatch("set_token", { token: res.data.token })
        const menus_tree = await getMenu({
          product_shortcode: 'MMS'
        })
        // 设置菜单权限
        this.$store.commit("setCurrentCopmpanyMenu", menus_tree.data)
        this.getLanguageAndUrl(this.$store.state.currentCopmpanyMenu)
        if (menus_tree.data.length <= 0) {
          this.$Message({
            text: this.$t("message_noMenuList"),
            color: 'rgba(0,0,0,0.78)'
          })
          return this.$router.go(-1)
        }
        this.$router.push({
          path: "/dashboard",
        })
      }
      if (res.code == '01413') {
        this.$router.push({
          path: "/login"
        })
      }
    },
    getLanguageAndUrl(arr) {
      arr.forEach((item) => {
        if (item.menus_tree && item.menus_tree.length > 0) {
          this.getLanguageAndUrl(item.menus_tree)
        } else {
          this.$store.commit("setAllMenuUrlList", {
            url: item.url,
            // title: item.language_name
            title: item.menu_name,
            function_uuid: item.function_uuid,
          })
        }
      })
    },
    backHandler() { //返回
      this.$router.go(-1)
    },
    resize(fn) {
      window.addEventListener("resize", function () {
        fn()
      })
    },
  },
}
</script>

<style scoped>
@import './bgd.css';

.forget-password {
  width: 100%;
  height: 100%;
  position: relative;
  /* background: url('../../assets/img/loginBg.png') no-repeat; */
  text-align: center;
  background-color: #0f46c1 !important;
}

.webResetPassword,
.webSendMail {
  width: 480px;
  height: 344px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
}

.webSendMail {
  height: 344px;
}

.webPc .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}

.forget-password /deep/ .btnGroup {
  justify-content: flex-end;
  /* height: 48px; */
  height: 32px;
}

.forget-password /deep/ .successBtn {
  /* width: 170px;
  height: 48px; */
  height: 32px;
  max-height: 48px !important;
  margin-left: 14px;
}

.forget-password /deep/ .cencelBtn {
  font-weight: medium;
  margin-right: 0;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  /* height: 347px; */
  height: 364px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
  width: 343px;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  min-width: 300px;
}

.phoneH5 .resetPassword {
  /* height: 500px; */
  height: 344px;
}

.phoneH5 .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}

.phoneH5 .phoneSubmitBtn /deep/ .successBtn {
  margin: 20px 0;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 5px;
  text-align: center;
  left: 50%;
  z-index: 10;
  color: rgba(255, 255, 255, 0.68);
  transform: translateX(-50%);
  font-family: var(--body-font-family) !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 128.91% !important;
}

.bottom p {
  letter-spacing: 1px;
  margin: 0;
}

/* @-webkit-keyframes bgd_rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes bgd_rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.bgd_left_box {
  transform: translate(-42%, 20%);
}
.bgd_right_box {
  transform: translate(40%, -57%);
}
.bgd_left_box_img {
  width: calc(64rem * 2);
  height: calc(68rem * 2);
  animation: bgd_rotate 20s ease-in-out infinite;
}
.bgd_right_box_img {
  width: calc(58rem * 4);
  height: calc(68rem * 4);
  animation: bgd_rotate 20s ease-in-out infinite;
}
@media screen and (max-width: 2000px) {
  .bgd_left_box {
    transform: translate(-42%, 20%);
  }
  .bgd_right_box {
    transform: translate(54%, -53%);
  }
  .bgd_left_box_img {
    width: calc(64rem);
    height: calc(68rem);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box_img {
    width: calc(58rem * 2);
    height: calc(68rem * 2);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 1400px) {
  .bgd_left_box {
    transform: translate(-55%, 16%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.9);
    height: calc(68rem * 0.9);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(54%, -32%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}

@media screen and (max-width: 992px) {
  .bgd_left_box {
    transform: translate(-68%, 22%);
  }
  .bgd_left_box_img {
    width: calc(64rem * 0.8);
    height: calc(68rem * 0.8);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
  .bgd_right_box {
    transform: translate(46%, -31%);
  }
  .bgd_right_box_img {
    width: calc(58rem * 1.5);
    height: calc(68rem * 1.5);
    animation: bgd_rotate 20s ease-in-out infinite;
  }
}
@media screen and (max-width: 800px) {
  .bgd_left_box {
    display: none;
  }
  .bgd_right_box {
    display: none;
  }
} */
</style>
